// extracted by mini-css-extract-plugin
var _1 = "NotFound_message__oXpbZ";
var _2 = "NotFound_messageContent__5gmY4";
var _3 = "NotFound_messageHeader__6QMV3";
var _4 = "NotFound_text__duXat";
export { _1 as "message", _2 as "messageContent", _3 as "messageHeader", _4 as "text" }
